import { AI_TOOL_MIS } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const buildAiToolMisRequest = (path, method = 'get', payload, userInfo = {}) => ({
  url: `${AI_TOOL_MIS}${path}`,
  method,
  headers: {
    'content-type': 'application/json',
    'x-user-info': JSON.stringify(userInfo),
  },
  authRequired: false,
  csrfToken: true,
  ...(payload !== undefined ? { payload } : {}),
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const fetchAiToolCatalog = (userInfo) => buildAiToolMisRequest('/tools', 'get', undefined, userInfo);

export const fetchAiToolMisAddOptions = (userInfo) => buildAiToolMisRequest('/options', 'get', undefined, userInfo);

export const createAiToolMisRequest = (payload, userInfo) => buildAiToolMisRequest(
  '/create',
  'post',
  payload,
  userInfo,
);

export const updateAiToolRequest = (requestId, payload, userInfo) => buildAiToolMisRequest(
  `/${requestId}`,
  'patch',
  payload,
  userInfo,
);

export const deleteAiToolRequest = (requestId, userInfo) => buildAiToolMisRequest(
  `/${requestId}`,
  'delete',
  undefined,
  userInfo,
);

export const deleteAiToolRequests = (requestIds, userInfo) => buildAiToolMisRequest(
  '/bulk',
  'delete',
  { requestIds },
  userInfo,
);
